import toast from 'react-hot-toast'
import { BsFillCaretRightFill } from 'react-icons/bs'
import { FaShareSquare } from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ACCOUNT_TYPE } from '../../../utils/constants'
import { addToCart } from '../../../slices/cartSlice'
import copy from 'copy-to-clipboard'

const CourseDetailsCard = ({course, setConfirmationModal, handleBuyCourse}) => {

    const { user } = useSelector((state) => state.profile)
    const { token } = useSelector((state) => state.auth)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const {
        thumbnail: ThumbnailImage,
        price: CurrentPrice,
    } = course[0]

    console.log("Course -> ", course)
    console.log("User -> ", user)

    let isEnrolled = false

    for(const id of course[0]?.studentsEnrolled){
      if(id._id === user?._id){
        isEnrolled = true
        break
      }
    }

    console.log("Isenrolled -> ", isEnrolled)

    const handleShare = () => {
        copy(window.location.href)
        toast.success("Link copied to clipboard")
    }

    const handleAddToCart = () => {
        if (user && user?.accountType === ACCOUNT_TYPE.INSTRUCTOR) {
            toast.error("You are an Instructor. You can't buy a course.")
            return
        }
        if (token) {
            //the cart stores plain course objects, and this page holds the course
            //inside an array, so unwrap it before handing it over
            dispatch(addToCart(course[0]))
            return
        }
        setConfirmationModal({
            text1: "You are not logged in!",
            text2: "Please login to add To Cart",
            btn1Text: "Login",
            btn2Text: "Cancel",
            btn1Handler: () => navigate("/login"),
            btn2Handler: () => setConfirmationModal(null),
        })
    }

  return (
    <>
      <div
        className={`flex flex-col gap-4 rounded-md bg-richblack-700 p-4 text-richblack-5`}
      >
        {/* Course Image */}
        <img
          src={ThumbnailImage}
          alt={course[0]?.courseName}
          className="max-h-[300px] min-h-[180px] w-[400px] overflow-hidden rounded-2xl object-cover md:max-w-full"
        />

        <div className="px-4">
          <div className="space-x-3 pb-4 text-3xl font-semibold">
            Rs. {CurrentPrice}
          </div>
          <div className="flex flex-col gap-4">
            {
              user?.accountType === "Student" && 
                <button
                  className="yellowButton"
                  onClick={
                    (user && isEnrolled)
                      ? () => navigate("/dashboard/enrolled-courses")
                      : handleBuyCourse
                  }
                >
                  {(user && isEnrolled)
                    ? "Go To Course"
                    : "Buy Now"
                  }
                </button>
            }
            {
              user?.accountType === "Instructor" && course[0]?.instructor?._id === user?._id &&
                <button
                  className="yellowButton"
                  onClick={() => navigate("/dashboard/instructor")}
                >
                  Go to Course Statistics
                </button>
            }
            {/* Students only, plus logged out visitors who get prompted to sign in.
            "not an instructor" also matched admins, who have no cart at all, and
            there is no point offering it to someone already enrolled */}
            {(!user || user?.accountType === ACCOUNT_TYPE.STUDENT) && !isEnrolled && (
              <button onClick={handleAddToCart} className="blackButton">
                Add to Cart
              </button>
            )}
          </div>
          <div>
            <p className="pb-3 pt-6 text-center text-sm text-richblack-25">
              30-Day Money-Back Guarantee
            </p>
          </div>

          <div className={``}>
            <p className={`my-2 text-xl font-semibold `}>
              This Course Includes :
            </p>
            <div className="flex flex-col gap-3 text-sm text-caribbeangreen-100">
              {course[0]?.instructions?.map((item, i) => {
                return (
                  <p className={`flex gap-2`} key={i}>
                    <BsFillCaretRightFill />
                    <span>{item}</span>
                  </p>
                )
              })}
            </div>
          </div>
          <div className="text-center">
            <button
              className="mx-auto flex items-center gap-2 py-6 text-yellow-100 "
              onClick={handleShare}
            >
              <FaShareSquare size={15} /> Share
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default CourseDetailsCard
